export default {
  stateKey: 'orderedList',
  order: 7,
  commandKey: 'toggleOrderedList',
  icon: ['far', 'list-ol'],
  appearance: {
    menu: true,
    bubble: true,
  },
}
